(() => {
  const initFilters = (scope = document) => {
    scope.querySelectorAll('[data-fac-filter-form]').forEach((form) => {
      if (form.dataset.facReady === 'true') return;
      form.dataset.facReady = 'true';

      form.querySelectorAll('[data-fac-filter-select]').forEach((select) => {
        select.addEventListener('change', () => {
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.submit();
        });
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initFilters());
  else initFilters();

  document.addEventListener('shopify:section:load', (event) => initFilters(event.target));
})();
